import { render, staticRenderFns } from "./iconItemColor.vue?vue&type=template&id=48430267"
import script from "./iconItemColor.vue?vue&type=script&lang=ts"
export * from "./iconItemColor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports